import { CommonLayout, CommonLayoutProps } from "./commonLayout";

export interface PublicPageProps extends CommonLayoutProps{}

export const PublicPage = (props: PublicPageProps) => (
  <CommonLayout {...props}/>
)
